// src/components/Footer.js

import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto">
      <div className="container mx-auto">
        <p className="text-center">Footer</p>
      </div>
    </footer>
  );
};

export default Footer;
